import { render, staticRenderFns } from "./auth-identity.vue?vue&type=template&id=02100473&scoped=true"
import script from "./auth-identity.vue?vue&type=script&lang=js"
export * from "./auth-identity.vue?vue&type=script&lang=js"
import style0 from "./auth-identity.vue?vue&type=style&index=0&id=02100473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02100473",
  null
  
)

export default component.exports